<div class="flex flex-col">
  <app-sidebar
    (clickSidebarButton)="handleSidebarButton($event)"
    (sidebarStateChanged)="handleSidebarStateChange($event)"
    [userData]="{ name: username, photoLink: '../assets/img/placeholder.jpg' }"
  ></app-sidebar>
</div>
